<template>
<div>
  <div class="bg-gray-50 px-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
    <label class="-mt-4 pl-1 absolute block text-xs font-medium text-gray-600">
      System
    </label>
    <dropdown v-model="telecom.system" :options="telcoSystemsValueList" @selected="onSystemChange"></dropdown>
    <text-field v-model="telecom.value" label="Value" class="col-span-2"></text-field>
    <v-btn v-if="telecom.system === 'sms'" class="telecom-item" @click="testSms">Test SMS</v-btn>
  </div>
</div>
</template>
<script>
import querystring from 'querystringify'
import Dropdown from '@/components/Dropdown.vue'
import TextField from '@/components/TextField.vue'

export default {
  data () {
    return {
      emailValidation: [
        value => !!value || 'address cannot be left blank',
        value => /.+@.+/.test(value) || 'email must be valid'
      ],
      telcoSystemsValueList: ['email', 'sms', 'phone']
    }
  },
  props: ['telecom'],
  components: {
    Dropdown, TextField
  },
  methods: {
    onSystemChange () {
      this.$emit('systemChanged', this.telecom);
    },
    async testSms () {
      const smsBody = {
        datacoding: 'auto',
        recipients: this.telecom.value,
        originator: 'STVINCENTS',
        body: 'Prior to your upcoming appointment at St Vincent’s Specialist Clinic, please complete the survey using the following link. This is an automated SMS, please do not reply',
      }
      console.log(`sending test sms to ${this.telecom.value}`)
      const mesg = querystring.stringify(smsBody)
      const smsResult = await this.axios.post('https://rest.messagebird.com/messages', mesg, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        auth: { username: 'AccessKey', password: process.env.VUE_APP_MESSAGEBIRD_API_KEY }
      })
      if (smsResult.status === 201) console.log('message sent success')
      else console.error(smsResult)
    }
  }
}
</script>
<style scoped>
.telecom-row {
  width: 100%;
}
.telecom-system {
  float: left;
  margin: 4px 10px 0 10px;
  width: 23%;
}
.telecom-item {
  float: left;
  margin: 0 8px 8px 0;
  padding-bottom: 0;
  width: 68%;
}
</style>
